<template lang="html">
    <div class="else">
        <div class="else_content" v-for="(m, index) in act" :key="index" @click="shuaxin">
            <router-link tag="div" :to="{ path:'/', query:{ id: m.id }  }" class="else_teacher">
                <div class="else_head">
                    <img :src="m.cover" alt="">
                    <div class="state" v-if="m.free_in_time > 0">
                        限时免费
                    </div>
                </div>
                <div class="else_act">
                    <p class="else_act_title">{{m.title}}</p>
                    <p class="else_act_time">报名时间: {{m.reg_time}}</p>
                    <p class="else_act_people"><span class="people_num">{{m.join_num}}</span>人参加</p>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            act : [],
        }
    },
    mounted(){
        this.$http({
            url: '/activity/detail',
            method: 'get',
            params: {
                activity_id : this.$route.query.id,
            },
        }).then( (res) => {
            this.act = res.data.more_list;
        })
    },
    methods:{
        shuaxin(){
            window.location.reload();
        }
    }
}
</script>

<style lang="css" scoped>
    .else{
        width: 100%;
    }
    .else_content{
        width: 100%;
        padding-top: 22px;
    }
    .else_teacher{
        height: 85px;
        display: flex;
    }
    .else_head{
        position: relative;
    }
    .else_head img{
        width: 123px;
        height: 85px;
        border-radius: 5px;
        object-fit: cover;
    }
    .state{
        height: 16px;
        line-height: 16px;
        font-size: 10px;
        color: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #F5A623;
        border-radius: 5px 0 16px 0;
        padding: 1px 10px;
    }
    .else_act{
        width: 100%;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .else_act_title{
        max-width: 235px;
        line-height: 18px;
        font-size: 14px;
        color: #1D2023;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .else_act_time{
        font-size: 11px;
        font-weight: 400;
        color: #606972;
    }
    .else_act_people{
        font-size: 12px;
        color: #9CA3A9;
        max-width: 240px;
        overflow: hidden;
        word-break:keep-all;
        white-space:nowrap;
    }
    .people_num{
        font-size: 14px;
        color: #87B43B;
    }

    @media (min-width: 500px) {
        .else_act_title{
            max-width: none;
        }
    }
</style>
